import { nativeShims } from '@/native/shims';

/**
 * haptics.ts — the one haptic-feedback chokepoint (M86). Menu taps carry a
 * physical tick alongside the sfxUiTick click, so touch navigation feels
 * "clicky" the way modern racing-game menus do.
 *
 * M111: inside the app shell the calls route through the native Haptics
 * plugin (real iPhone haptics at last — Safari never had navigator.vibrate).
 * On the web the standard Vibration API stays: Android browsers buzz, iOS
 * Safari silently no-ops. Nothing else touches vibration directly.
 */

function buzz(kind: 'tick' | 'impact', pattern: number | number[]): void {
  if (nativeShims.haptic) {
    nativeShims.haptic(kind); // the plugin call is fire-and-forget + caught
    return;
  }
  // Feature-detected + try/caught: some WebViews throw outside a user
  // gesture, and haptics must never be able to break a menu tap.
  try {
    navigator.vibrate?.(pattern);
  } catch {
    /* never fatal */
  }
}

/** The standard UI tap — a barely-there tick (pairs with sfxUiTick). */
export function hapticTick(): void {
  buzz('tick', 8);
}

/** A firmer double-beat for bigger moments (chapter turns, confirmations). */
export function hapticImpact(): void {
  buzz('impact', [14, 30, 10]);
}
